import _toConsumableArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
var __jsx = React.createElement;
import React from "react";
import classNames from "classnames";
import { getInputBorderAndBackgroundClasses } from "../../../utils/fieldValidation";
import { normalizePatientRaceSelection } from "../utils/fieldValidator";
var BadgeMultiSelectInput = function BadgeMultiSelectInput(_ref) {
  var value = _ref.value,
    options = _ref.options,
    onChange = _ref.onChange,
    disabled = _ref.disabled,
    isEmpty = _ref.isEmpty,
    isRequired = _ref.isRequired,
    errorMessage = _ref.errorMessage,
    isShouldBeBlankError = _ref.isShouldBeBlankError,
    fieldName = _ref.fieldName;
  // Ensure value is always an array of strings (convert numbers to strings for consistency)
  var safeValue = Array.isArray(value) ? value.map(function (v) {
    return String(v);
  }) : value ? [String(value)] : [];
  var shouldShowServerError = !isEmpty && !!errorMessage;
  var borderAndBackgroundClasses = getInputBorderAndBackgroundClasses(shouldShowServerError, isRequired !== null && isRequired !== void 0 ? isRequired : false, isEmpty !== null && isEmpty !== void 0 ? isEmpty : false);
  var handleToggleOption = function handleToggleOption(optionValue) {
    if (disabled) return;
    var isSelected = safeValue.some(function (v) {
      return String(v) === String(optionValue);
    });
    var newValue;
    if (isSelected) {
      // Remove from selection
      newValue = safeValue.filter(function (item) {
        return String(item) !== String(optionValue);
      });
    } else {
      // Add to selection
      newValue = [].concat(_toConsumableArray(safeValue), [optionValue]);
      // Normalize values for Patient_Race field (handle mutual exclusivity)
      if (fieldName) {
        newValue = normalizePatientRaceSelection(fieldName, newValue, optionValue);
      }
    }
    onChange(newValue);
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: classNames("flex flex-wrap gap-3 rounded-lg", {
      "p-3 border": isRequired && isEmpty || shouldShowServerError
    }, borderAndBackgroundClasses)
  }, options.map(function (option) {
    var isSelected = safeValue.some(function (v) {
      return String(v) === String(option.value);
    });
    return /*#__PURE__*/React.createElement("button", {
      key: option.value,
      type: "button",
      onClick: function onClick() {
        return handleToggleOption(option.value);
      },
      disabled: disabled,
      className: classNames("px-4 py-2 rounded-full text-md font-medium transition-all border", {
        "bg-teal-400 text-[#FFFFFF] dark:text-gray-100 border-teal-400 dark:bg-teal-400 dark:border-teal-400": isSelected && !disabled,
        "bg-[#F3F4F4] text-gray-600 border-gray-400 hover:bg-gray-200/80 dark:bg-[#0C1723] dark:text-gray-300 dark:border-gray-600 dark:hover:bg-gray-800": !isSelected && !disabled,
        "opacity-50 cursor-not-allowed": disabled,
        "cursor-pointer": !disabled
      })
    }, option.label);
  })), shouldShowServerError && /*#__PURE__*/React.createElement("div", {
    className: "w-full mt-1 ml-2 text-left text-red-500 dark:text-red-400 text-sm"
  }, errorMessage));
};
export default BadgeMultiSelectInput;